/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const GlyphInterfaceIcCInfo = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 24 24",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.4c-5.294 0-9.6 4.306-9.6 9.6s4.306 9.6 9.6 9.6 9.6-4.306 9.6-9.6-4.306-9.6-9.6-9.6zm2.126 14.627c-.528.208-2.361 1.083-3.417.153a1.34 1.34 0 01-.472-1.055c0-.798.262-1.494.735-3.165.083-.316.185-.726.185-1.05 0-.561-.213-.71-.79-.71-.282 0-.594.1-.876.206l.156-.64c.63-.256 1.42-.568 2.097-.568 1.015 0 1.762.507 1.762 1.47 0 .277-.048.764-.149 1.1l-.583 2.066c-.121.417-.34 1.338-.001 1.61.332.27 1.12.127 1.51-.056l-.157.64zM13.162 8.8a1.2 1.2 0 110-2.401 1.2 1.2 0 010 2.4z"
  }));
};
export default GlyphInterfaceIcCInfo;